import { RouteObject } from 'react-router-dom'
import WalletPage from '.'
import WalletLayout from 'layout/wallet/walletLayout'
import ErrorBug from 'components/errors/bugs'

export const walletRoutes: RouteObject[] = [
    {
        path: '/wallet',
        element: <WalletLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                path: '',
                element: <WalletPage />,
            },
        ],
    },
]
